export enum LoopIterationType {
  NOT_USED = "NOT_USED",
  INDEX = "INDEX",
  SET_NAME = "SET_NAME",
  PARAMETER_VALUE = "PARAMETER_VALUE",
  VALUE_TYPE = "VALUE_TYPE"
}
